"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getInputAriaDescribedBy = void 0;

var getInputAriaDescribedBy = function getInputAriaDescribedBy(_ref) {
  var _ref$totalsId = _ref.totalsId,
      totalsId = _ref$totalsId === void 0 ? '' : _ref$totalsId,
      _ref$inputFooterId = _ref.inputFooterId,
      inputFooterId = _ref$inputFooterId === void 0 ? '' : _ref$inputFooterId,
      _ref$inputWrapperId = _ref.inputWrapperId,
      inputWrapperId = _ref$inputWrapperId === void 0 ? '' : _ref$inputWrapperId;
  var inputDescribedBy = [totalsId, inputFooterId, inputWrapperId].join(' ').trim().replace(/\s+/g, ' '); // reduce repeated whitespace to " "

  return inputDescribedBy || undefined;
};

exports.getInputAriaDescribedBy = getInputAriaDescribedBy;